import React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/index'
// utils
import { required } from 'utils/index'

// styled
const Form = styled('form')`
  padding-bottom: 24px;
  width: 100%;
`

const DetailsForm: React.FunctionComponent<InjectedFormProps> = ({ handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container justifyContent={'space-between'} spacing={2}>
        <Grid size={6}>
          <ReduxInput name={'name'} label={'Name'} validate={required} disabled />
        </Grid>
        <Grid size={6}>
          <ReduxInput name={'apiName'} label={'API Name'} validate={required} disabled />
        </Grid>
      </Grid>
    </Form>
  )
}

export default reduxForm({
  form: Forms.OBJECT_DETAILS_FORM
})(DetailsForm)
